/* The same-name question inside the upload window (decision 2421). */
.question {
  display: grid;
  gap: var(--space-2);
  padding: var(--space-3);
  border: var(--field-border-width) solid var(--border);
  border-radius: var(--radius-small);
  background: var(--surface-2);
}

.text {
  margin: 0;
}

.hint {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-caption);
}

.answers {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}
